import {
  extractInput, isListLenLimitExceeded, initList,
} from '../utils'
import { get } from './get'

const addStatusToQuery = (originalQuery, status) => {
  let augmentedQuery
  // status = accepted -> already employed, otherwise blocked
  augmentedQuery = originalQuery.where('confirmed', '==', status === 'accepted')
  if (status !== 'accepted') {
    augmentedQuery = originalQuery.where('status', '==', 'blocked')
  }
  return augmentedQuery
}

const buildQueryByFilters = (nonAdminQuery, queryParams) => {
  const minBirthday = new Date()
  minBirthday.setFullYear(minBirthday.getFullYear() - 50)

  const {
    role, state, city, plan, age, isSubcontractor, residency,
  } = queryParams
  // build base query
  let query = nonAdminQuery
  // build filter query
  if (role) {
    query = query.where('role', '==', role)
  }
  if (state) {
    query = query.where('address.state', '==', state)
  }
  if (city.length > 0) {
    query = query.where('address.city', 'in', city)
  }
  if (plan) {
    const love = plan === 'suoritettu'
    query = query.where('love', '==', love)
  }
  if (age) {
    query = query.where('birthday', '<', `${minBirthday.getFullYear()}-${minBirthday.getMonth() + 1}-${minBirthday.getDate()}`).where('birthday', '!=', '')
  }
  if (isSubcontractor) {
    query = query.where('isSubcontractor', '==', true)
  }
  if (residency) {
    query = query.where('residency', '==', residency)
  }
  return query.orderBy('created', 'desc')
} 

const augmentQuery = (query, queryParams) => {
  const {
    status, list, perPage,
  } = queryParams
  const input = extractInput(queryParams)
  let augmentedQuery = addStatusToQuery(query, status)
  const updatedList = initList(input, list)
  if (isListLenLimitExceeded(updatedList)) {
    const lastListItem = updatedList[updatedList.length - 1]
    augmentedQuery = augmentedQuery.startAfter(lastListItem.created.toDate())
  }
  return augmentedQuery.limit(perPage)
}

const fetchUsers = queryParams => get(queryParams, buildQueryByFilters, augmentQuery)

export {
  // eslint-disable-next-line import/prefer-default-export
  fetchUsers,
}